import { Attachment } from './attachment.model';
import { User } from './user.model';
import { BusinessUser } from './business-user.model';

export class Item {
  id: number;
  call_id: number;
  user_id?: number;
  origin?: string;
  media?: string;
  send_to?: string;
  send_cco?: string;
  description: string;
  type: string;
  limit_date: string;
  is_complete: boolean;
  user?: User | BusinessUser;
  added_at: string;
  files: any;
}
